import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  OceanInsurance: [],
};

const OceanInsuranceSlice = createSlice({
  name: "OceanInsurance",
  initialState,
  reducers: {
    updateOceanInsurance: (state, action) => {
  
      state.OceanInsurance = action.payload;

    },
  },
});

// Export the action
export const { updateOceanInsurance } = OceanInsuranceSlice.actions;
// Export the reducer
export default OceanInsuranceSlice.reducer;
